import { Users, CheckCircle2 } from 'lucide-react';
import type { Committee } from './orgData';
import { getPersonById } from './orgData';

interface CommitteeCardProps {
  committee: Committee;
}

export default function CommitteeCard({ committee }: CommitteeCardProps) {
  const president = getPersonById(committee.presidentId);
  const arbitrage = getPersonById(committee.arbitrageFinalId);

  return (
    <div className="bg-slate-900/85 rounded-2xl border border-indigo-500/50 p-4 shadow-lg space-y-3">
      <div className="flex items-start gap-2">
        <div className="w-9 h-9 rounded-xl bg-indigo-600/20 flex items-center justify-center text-indigo-200 border border-indigo-400/70 shadow-inner">
          <Users className="w-5 h-5" />
        </div>
        <div>
          <p className="text-[0.7rem] uppercase tracking-wide text-indigo-300 font-semibold">
            Comité clé
          </p>
          <h4 className="text-sm font-semibold text-slate-50">{committee.name}</h4>
          <p className="text-[0.7rem] text-slate-300 mt-0.5">
            Matrice TI : priorités, capacité, adoption PRIsME, arbitrages N2↔N3.
          </p>
        </div>
      </div>

      <div className="space-y-1 text-[0.72rem] text-slate-100 border-t border-slate-700/70 pt-2">
        {president && (
          <p>
            <span className="font-semibold text-slate-200">Président :</span> {president.name} – {president.title}
          </p>
        )}
        <p>
          <span className="font-semibold text-slate-200">Membres :</span>{' '}
          {committee.memberIds
            .map((id) => getPersonById(id))
            .filter(Boolean)
            .map((p) => p!.name)
            .join(', ')}
        </p>
        {arbitrage && (
          <p>
            <span className="font-semibold text-slate-200">Arbitrage final :</span> {arbitrage.name}
          </p>
        )}
      </div>

      <div className="space-y-1.5 text-[0.7rem] text-slate-200 border-t border-slate-700/70 pt-2">
        <p className="font-semibold text-slate-100">Mandat</p>
        <p className="text-slate-200/90">{committee.mandate}</p>
        <ul className="space-y-0.5 mt-1">
          {committee.rules.map((rule) => (
            <li key={rule} className="flex items-start gap-1.5">
              <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0 mt-[2px]" />
              <span>{rule}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

